
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsd763cff5a9405486ecb1e4c3181454dcen from './en.yaml'
            i18n.addResourceBundle('en', 'd763cff5a9405486ecb1e4c3181454dc', flattenObject(nsd763cff5a9405486ecb1e4c3181454dcen), true, true);
        
        export default 'd763cff5a9405486ecb1e4c3181454dc';
    